/* eslint-disable no-case-declarations */
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import { ColumnDirective, ColumnsDirective, CommandColumn, Edit, GridComponent, Inject, Selection, Sort, Toolbar } from '@syncfusion/ej2-react-grids';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { ToastUtility } from '@syncfusion/ej2-react-notifications';
import moment from 'moment';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { getUserDetails } from '../../helpers/authentication';
import { LoadAPIData, SaveAPIData } from '../../helpers/DataHelper';
import { DatePresets, OrderStatuses, SearchGridToolbar, ConfirmDialogStyles, DownloadCarts } from '../../helpers/Global';
import { GridDateFormat } from '../../helpers/GridSettings';
import { ShowToast } from '../../helpers/Toast';
import { fieldRequired } from '../../helpers/validation';
import OrderStatusFilter from './OrderStatusFilter';
import { confirm } from "react-confirm-box";


export default function Cart() {
  const navigate = useNavigate();
  const gridRef = useRef(null);
  const [editData, setEditData] = useState();
  const [filteredData, setFilteredData] = useState([]);
  const [editId, setEditId] = useState(0);

  const [cartId, setCartId] = useState('');
  const [userId, setUserId] = useState(0);
  const [orderType, setOrderType] = useState(0);
  const [dateStarted, setDateStarted] = useState(new Date());
  const [dateSubmitted, setDateSubmitted] = useState(new Date());
  const [dateComplete, setDateComplete] = useState(new Date());
  const [numItems, setNumItems] = useState(0);
  const [orderId, setOrderId] = useState(0);
  const [orderNumber, setOrderNumber] = useState('');
  const [amount, setAmount] = useState(0);
  const [deliveryFee, setDeliveryFee] = useState(0);
  const [vat, setVat] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [promoCode, setPromoCode] = useState(0);
  const [useCredit, setUseCredit] = useState(false);
  const [stockCheck, setStockCheck] = useState(false);
  const [status, setStatus] = useState(0);
  const [statusName, setStatusName] = useState('');
  const [deliveryAddressId, setDeliveryAddressId] = useState(0);
  const [instructions, setInstructions] = useState('');
  const [statusMessage, setStatusMessage] = useState('');
  const [paymentMessage, setPaymentMessage] = useState('');
  const [paymentMeta, setPaymentMeta] = useState('');
  const [deliveryMessage, setDeliveryMessage] = useState('');
  const [deliveryMeta, setDeliveryMeta] = useState('');
  const [deliveryAddress, setDeliveryAddress] = useState();

  const [orderData, setOrderData] = useState([]);
  const [notes, setNotes] = useState();

  const [adminNote, setAdminNote] = useState('');

  const [fullName, setFullName] = useState('');
  const [emailAddress, setEmailAddress] = useState('');

  const [editModal, setEditModal] = useState(false);
  const [noteModal, setNoteModal] = useState(false);

  const [filterStart, setFilterStart] = useState(new Date(moment().add(-180, "days")));
  const [filterEnd, setFilterEnd] = useState(new Date());
  const [filterSelected, setFilterSelected] = useState();

  const toggle = () => setEditModal(!editModal);
  const toggleNote = () => setNoteModal(!noteModal);


  const onAction = useCallback(async ({ action, id, row }) => {

    switch (action) {
      case "slip":
        getPackingSlip(row.cartId);
        break;
      case "delivery":
        if (await confirm("Are you sure you want to send this order for delivery?", ConfirmDialogStyles)) {
          sendForDelivery(row.cartId);
        }
        
        break;
      case "view":
        editItem(row);
        break;
      case "cancel":
        if (await confirm("Are you sure you want to cancel this order?", ConfirmDialogStyles)) {
          updateStatus(row.cartId, 110);
        }
        break;
      case "complete":
        if (await confirm("Are you sure you want to set this order to complete?", ConfirmDialogStyles)) {
          updateStatus(row.cartId, 3);
        }
        break;
      default:
        break;
    }

  }, []);

  const updateStatus = async (CartId, Status) => {
    const data = {CartId: CartId, Status: Status};
    //console.log(await SaveAPIData('/api/cart/ProcessDelivery/' + CartId));
    //loadData();
    const result = await SaveAPIData('/api/cart/updatestatus/'+CartId+'/'+Status, data, 'POST');
    if (result.success) {

      ShowToast('Order Status', 'The order status was successfully updated!', 'toast-success');
      loadData();
    }
    else {
      ShowToast('Order Status', 'There was an error saving the order status!', 'toast-danger');
    }
  }

  const sendForDelivery = async (CartId) => {
    console.log(await LoadAPIData('/api/cart/ProcessDelivery/' + CartId));
    loadData();
  }

  const openOrderLabel = (response) => {
    if (
      response?.data &&
      response.data.length > 0 &&
      response.data[0]?.orderData?.orderLabel
    ) {
      const url = response.data[0].orderData.orderLabel;
      window.open(url, "_blank", "noopener,noreferrer");
    } else {
      console.error("No order label found in response");
    }
  };

  const getPackingSlip = async (CartId) => {
    var data = await LoadAPIData('/api/cart/GetDeliveryPackingSlip/' + CartId);
    console.log(data);
    if (data) {
      //console.log(JSON.parse(data));
      openOrderLabel(JSON.parse(data));
    } else {
      ToastUtility.show({
        title: 'Packing Slip', content: 'There is no Packing Slip available yet!', timeOut: 5000, position: { X: 'Right', Y: 'Top' }, showCloseButton: true, cssClass: 'toast-danger'
      });
    }
  }

  const getCommands = useCallback((row) => {
    try {
      if (!row || typeof row !== 'object') return null;

      const status = Number(row?.status ?? row?.Status ?? 0);
      const id = row?.id ?? row?.orderId ?? row?.cartId ?? null;

      const stop = (e) => e?.stopPropagation?.();
      const mk = (action) => (e) => {
        e?.preventDefault?.();
        e?.stopPropagation?.();
        onAction({ action, id, row });
      };

      if (!id) {
        return (
          <div className="btn-group btn-group-sm" role="group" onClick={stop}>
            <button type="button" className="btn btn-outline-secondary" onClick={mk('view')} title="View">
              <i className="fa-solid fa-eye" />
            </button>
          </div>
        );
      }

      switch (status) {
        case 2: // Pending Delivery
          return (
            <div className="btn-group btn-group-sm" role="group" onClick={stop}>
              <button type="button" className="btn btn-outline-dark" onClick={mk('delivery')} title="Send for delivery">
                <i className="fa-solid fa-truck-ramp-box" />
              </button>
              <button type="button" className="btn btn-outline-dark" onClick={mk('view')} title="View order">
                <i className="fa-solid fa-eye" />
              </button>
              <button type="button" className="btn btn-outline-success" onClick={mk('complete')} title="Order complete">
                <i className="fa-solid fa-check" />
              </button>
              <button type="button" className="btn btn-outline-danger" onClick={mk('cancel')} title="Cancel order">
                <i className="fa-solid fa-ban" />
              </button>
            </div>
          );
        case 3: // Complete
        case 10: // User Cancelled
          return (
            <div className="btn-group btn-group-sm" role="group" onClick={stop}>
              <button type="button" className="btn btn-outline-dark" onClick={mk('view')} title="View order">
                <i className="fa-solid fa-eye" />
              </button>
            </div>
          );
        case 4: // Shipping in progress
          return (
            <div className="btn-group btn-group-sm" role="group" onClick={stop}>
              <button type="button" className="btn btn-outline-dark" onClick={mk('slip')} title="Request packing slip">
                <i className="fa-solid fa-file-invoice" />
              </button>
              <button type="button" className="btn btn-outline-dark" onClick={mk('view')} title="View order">
                <i className="fa-solid fa-eye" />
              </button>
              <button type="button" className="btn btn-outline-success" onClick={mk('complete')} title="Order complete">
                <i className="fa-solid fa-check" />
              </button>
            </div>
          );
        default:
          return (
            <div className="btn-group btn-group-sm" role="group" onClick={stop}>
              <button type="button" className="btn btn-outline-dark" onClick={mk('view')} title="View order">
                <i className="fa-solid fa-eye" />
              </button>
              <button type="button" className="btn btn-outline-danger" onClick={mk('cancel')} title="Cancel order">
                <i className="fa-solid fa-ban" />
              </button>
            </div>
          );
      }
    } catch (err) {
      console.error('getCommands error:', err, row);
      return null;
    }
  }, [onAction]);

  const updateDateFilter = (update) => {
    if (update.startDate) setFilterStart(new Date(update.startDate));
    if (update.endDate) setFilterEnd(new Date(update.endDate));
  }

  const loadData = async () => {
    const carts = await LoadAPIData('/api/cart/getadmincarts');
    const cartDetail = carts.filter(item => item.status !== 0).map(item => {
      const statusMatch = OrderStatuses.find(s => s.value === item.status);
      return {
        ...item,
        fullName: `${item.firstName} ${item.lastName}`,
        dateSubmitted: new Date(item.dateSubmitted),
        orderNumber: `TC${item.orderId.toString().padStart(4, '0')}`,
        orderData: JSON.parse(item.orderData || '[]'),
        notes: JSON.parse(item.notes || '[]'),
        deliveryMeta: item.deliveryMeta ? JSON.parse(item.deliveryMeta) : "",
        deliveryAddress: item.deliveryAddress ? JSON.parse(item.deliveryAddress) : "",
        statusName: statusMatch ? statusMatch.title : 'Unknown',
        subTotal: JSON.parse(item.orderData || '[]').reduce((previousValue, currentValue) => { return previousValue + currentValue.TotalCharged; }, 0),

      };
    });

    setEditData(cartDetail);
  }

  const validateForm = () => {
    var valid = true;
    valid &= fieldRequired(adminNote, 'tbAdminNoteError', '* required');

    return valid;
  }

  const upsertNotesForCart = useCallback((cartId, notesArray) => {
    //console.log(cartId, notesArray)
    setEditData(prev =>
      prev.map(r => (r.cartId === cartId ? { ...r, notes: notesArray } : r))
    );
  }, []);

  const loadNoteData = useCallback(async (cartId) => {
    const data = await LoadAPIData(`/api/adminordernotes/loadforcart/${cartId}`);
    const notes = Array.isArray(data) ? data : [];     // normalize
    upsertNotesForCart(cartId, notes);
    //setNotes(notes);
    return notes;
  }, [upsertNotesForCart]);

  const saveNoteItem = async (event) => {
    event.stopPropagation();

    if (validateForm()) {
      const data = { id: 0, cartId: editId, adminNote: adminNote };

      const result = await SaveAPIData('/api/adminordernotes', data, 'POST');
      if (result.success) {

        ShowToast('Admin Order Notes', 'The order note was successfully saved!', 'toast-success');
        setAdminNote('');
        const notes = await loadNoteData(editId);
        setNotes(notes);
      }
      else {
        ShowToast('Admin Order Notes', 'There was an error saving the order note!', 'toast-danger');
      }
      toggleNote();
    }
  }

  const editItem = (data) => {
    if (data) {
      console.log(data);
      ////console.log(filteredData);
      //const data = editData?.find((item) => { return item.id === id });
      setEditId(data.id);

      setCartId(data.cartId);
      setUserId(data.userId);
      setOrderType(data.orderType);
      setDateStarted(data.dateStarted);
      setDateSubmitted(data.dateSubmitted);
      setDateComplete(data.dateComplete);
      setNumItems(data.numItems);
      setOrderId(data.orderId);
      setAmount(data.amount);
      setDeliveryFee(data.deliveryFee);
      setVat(data.vat);
      setSubTotal(data.subTotal);
      setPromoCode(data.promoCode);
      setUseCredit(data.useCredit);
      setStockCheck(data.stockCheck);
      setStatus(data.status);
      setDeliveryAddressId(data.deliveryAddressId);
      setInstructions(data.instructions);
      setStatusMessage(data.statusMessage);
      setPaymentMessage(data.paymentMessage);
      setPaymentMeta(data.paymentMeta);
      setDeliveryMessage(data.deliveryMessage);
      setDeliveryMeta(data.deliveryMeta);

      setOrderNumber(data.orderNumber);
      setStatusName(data.statusName);
      setOrderData(data.orderData);
      setNotes(data.notes);
      setFullName(data.fullName);
      setEmailAddress(data.emailAddress);
      setDeliveryAddress(data.deliveryAddress);

    }
    else {
      //clear state fields
      setEditId(0);

      setCartId('');
      setUserId(0);
      setOrderType(0);
      setDateStarted(null);
      setDateSubmitted(null);
      setDateComplete(null);
      setNumItems(0);
      setOrderId(0);
      setAmount(0);
      setDeliveryFee(0);
      setVat(0);
      setSubTotal(0);
      setPromoCode(0);
      setUseCredit(false);
      setStockCheck(false);
      setStatus(0);
      setDeliveryAddressId(0);
      setInstructions('');
      setStatusMessage('');
      setPaymentMessage('');
      setPaymentMeta('');
      setDeliveryMessage('');
      setDeliveryMeta('');

      setOrderNumber('');
      setStatusName('');
      setOrderData([]);
      setNotes([]);

      setFullName('');
      setEmailAddress('');
      setDeliveryAddress();
    }
    setEditModal(true);
  };

  const getSelectedOrders = () => {
    if (!gridRef.current) return [];
    //const selectedRecords = gridRef.current.getSelectedRecords();
    const selectedIds = (gridRef.current?.getSelectedRecords?.() || [])
      .map(r => Number(r.id))
      .filter(id => !isNaN(id));
    console.log('Selected records:', selectedIds);
    return selectedIds;
  };

  const exportExcelReport = async (event) => {
    event.stopPropagation();
    const carts = getSelectedOrders();
    if (carts.length > 0)
      DownloadCarts(carts, "Online Orders");
    else 
      ShowToast('Order Export', 'Please select one or more orders to export!', 'toast-danger');
  }

  useEffect(() => {
    if (!Array.isArray(editData)) {
      setFilteredData([]);
      return;
    }
    //console.log("filtering data");
    // normalize date bounds (inclusive range)
    const start = new Date(filterStart);
    start.setHours(0, 0, 0, 0);
    const end = new Date(filterEnd);
    end.setHours(23, 59, 59, 999);

    const selectedStatuses = Array.isArray(filterSelected) ? filterSelected : [];

    const next = editData.filter((r) => {
      const d = r.dateSubmitted;
      if (!d || isNaN(d)) return false;

      const inRange = d >= start && d <= end;
      const statusOk = selectedStatuses.length === 0 || selectedStatuses.includes(r.status);

      return inRange && statusOk;
    });
    //console.log(next);
    setFilteredData(next);

  }, [editData, filterStart, filterEnd, filterSelected]);

  useEffect(() => {
    loadData();
  }, []);

  return (
    <>
      <div className="row mb-2">
        <div className="col-md-6 "><h1>Order Dashboard</h1></div>
        <div className="col-md-6 text-end align-self-center">
          <Button className="mx-2" color="dark" outline size="sm" data-recordid="0" onClick={e => navigate("/admin/administration")}><i className="fas fa-chevron-left mr-2"></i> Back To Admin</Button>
          <Link to="/admin" className="btn btn-sm text-light" style={{ background: "#74bc1f" }} >Admin dashboard <i className='fas fa-arrow-circle-right'></i></Link>
        </div>
      </div>

      <div className="card card-body mb-3">
        <div className="row">
          <div className="col-md-3">
            <label>Date Filter</label><br />
            <DateRangePickerComponent id="daterangepicker" placeholder='Select a range' separator='to' startDate={filterStart} endDate={filterEnd} presets={DatePresets} format='yyyy-MM-dd' change={updateDateFilter} />
          </div>
          <div className="col-md-7">
            <label>Status Filter</label>
            <OrderStatusFilter onChange={(values) => {setFilterSelected(values);}} />
          </div>
          <div className="col-md-2 text-end align-self-end">
            <button className="btn btn-sm btn-success" onClick={exportExcelReport}>Excel Export <i className="fa-solid fa-file-excel ms-2"></i></button>
          </div>
        </div>
      </div>

      <GridComponent dataSource={filteredData ?? []} ref={gridRef} allowSorting={true} locale='en-ZA' toolbar={SearchGridToolbar} selectionSettings={{ type: 'Multiple', checkboxOnly: true }} >
        <ColumnsDirective>
          <ColumnDirective type='checkbox' width='20' />

          <ColumnDirective field='orderNumber' width='50' headerText="Order Num." />
          <ColumnDirective field='fullName' width='80' headerText="Customer" />
          <ColumnDirective field='dateSubmitted' width='50' headerText="Date" type="datetime" format={GridDateFormat} />
          <ColumnDirective field='statusName' width='60' headerText="Status" />
          <ColumnDirective field='amount' width='50' headerText="Amount" format='N2' textAlign='Right' />
          <ColumnDirective field="id" headerText='Actions' width='60' template={getCommands} headerAlign='Right' textAlign='Right' />

        </ColumnsDirective>
        <Inject services={[Sort, Edit, Selection, CommandColumn, Toolbar]} />
      </GridComponent>

      <Modal isOpen={editModal} toggle={toggle} scrollable size="xl" backdrop="static">
        <ModalHeader toggle={toggle}>
          Order Details - {orderNumber}
          <div className="text-muted" style={{ fontSize: "12px" }}>{statusName}</div>
        </ModalHeader>
        <ModalBody>
          <table className="table table-bordered table-sm table-striped">
            <thead>
              <tr>
                <th className="fw-bold" scope="col">Product Name</th>
                <th className="fw-bold" scope="col">SKU</th>
                <th className="fw-bold text-center" scope="col">Quantity</th>
                <th className="fw-bold text-end" scope="col">Sub Total</th>
                <th className="fw-bold text-end" scope="col">Total</th>
              </tr>
            </thead>
            <tbody>
              {orderData && orderData.map((data) => (
                <tr className="history" key={data.Id}>
                  <td><small>{data.Title}</small></td>
                  <td>{data.Sku}</td>
                  <td className="text-center"><small>{data.Qty}</small></td>
                  <td className="text-end"><small>{data.PriceCharged.toCurrencyString()}</small></td>
                  <td className="text-end"><small>{data.TotalCharged.toCurrencyString()}</small></td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className='w-100 small mt-1 mb-3'>
            <div className="text-end row" style={{ borderTop: "2px solid black" }}>
              <strong className="col text-end" style={{ color: "#74bc1f" }}>TOTAL</strong>
              <strong className="col-md-2 pe-3">{subTotal.toCurrencyString()}</strong>
            </div>
            <div className="text-end row">
              <strong className="col text-end" style={{ color: "#74bc1f" }}>DELIVERY FEE</strong>
              <strong className="col-md-2 pe-3">{deliveryFee.toCurrencyString()}</strong>
            </div>
            <div className="text-end row">
              <strong className="col text-end" style={{ color: "#74bc1f" }}>GRAND TOTAL</strong>
              <strong className="col-md-2 pe-3" style={{ borderTop: "2px solid black", borderBottom: "4px double black" }} >{amount.toCurrencyString()}</strong>
            </div>
          </div>


          <div className="row">
            <div className="col-md-4">
              <h6 className="bordered">Customer Details</h6>
              <div className="small">
                <div><strong>Customer Name: </strong>{fullName}</div>
                <div><strong>Mobile Number: </strong>{deliveryAddress?.MobileNumber}</div>
                <div><strong>Email: </strong>{emailAddress}</div>
                <div><strong>Instructions: </strong>{instructions ? (instructions !== 'null' ? instructions : "None") : "None"}</div>
                <div><b>Payment Status:</b> {paymentMessage}</div>
                <div><b>Tracking Code:</b> {deliveryMeta?.data?.attributes.orderData?.trackingCode}</div>
              </div>
            </div>
            <div className="col-md-4">
              <h6 className="bordered">Delivery Address</h6>
              <div className="small">
                {deliveryAddress?.Company ? (<>{"C/O: " + deliveryAddress?.Company} <br /></>) : ""}
                {deliveryAddress?.Address}<br />
                {deliveryAddress?.Apartment ? (<>{deliveryAddress?.Apartment} <br /></>) : ""}
                {deliveryAddress?.Suburb ? (<>{deliveryAddress?.Suburb} <br /></>) : ""}
                {deliveryAddress?.City ? (<>{deliveryAddress?.City} <br /></>) : ""}
                {deliveryAddress?.Province ? (<>{deliveryAddress?.Province} <br /></>) : ""}
                {deliveryAddress?.PostalCode ? deliveryAddress?.PostalCode : ""}
              </div>
            </div>
            <div className="col-md-4">
              <h6 className="bordered">Notes</h6>
              <div className="small">
                {notes?.length > 0 ? notes.map((item, index) => (
                  <>
                    <div key={index} className={item.AddedBy === getUserDetails().id ? "speech-bubble sb2" : "speech-bubble sb1"}>
                      <span>{item.AdminNote}</span>
                    </div>
                    <div className={item.AddedBy === getUserDetails().id ? "text-end small mb-3" : "text-start small mb-3"}>{item.UserName} - {new Date(item.DateAdded).toDateString()}</div>
                  </>)) :
                  <i>No notes for this order</i>}
              </div>

              <hr />
              <div className="text-end">
                <button className="btn btn-sm btn-info" onClick={toggleNote}><i className="fa-solid fa-plus me-2"></i> Add Note</button>
              </div>
            </div>
          </div>

        </ModalBody>
        <ModalFooter>
          <Button color="dark" size="sm" onClick={toggle}>Close <i className="far fa-times-circle ms-2"></i></Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={noteModal} toggle={toggleNote} scrollable size="lg" backdrop="static">
        <ModalHeader toggle={toggleNote}>Add New Order Note</ModalHeader>
        <ModalBody>

          <div className='mb-3'>
            <TextBoxComponent id='tbAdminNote' name='tbAdminNote' multiline={true} htmlattributes={{ maxLength: '2500', rows: '4' }} placeholder='Note' type='text' maxLength='2500' floatLabelType='Auto' showClearButton={true} value={adminNote} onChange={e => setAdminNote(e.value)} />
            <div id='tbAdminNoteError' className='error-message' />
          </div>


        </ModalBody>
        <ModalFooter>
          <Button color="dark" size="sm" onClick={toggleNote}>Cancel <i className="far fa-times-circle ms-2"></i></Button>
          <Button color="success" size="sm" onClick={saveNoteItem}>Save <i className="far fa-check-circle ms-2"></i></Button>
        </ModalFooter>
      </Modal>


    </>
  );
}

